import { Phone, Award, Star, MapPin, ShieldCheck } from "lucide-react";
import { ARTISAN, ARTISAN_PHOTO, ARTISAN_BADGE, COMPANY } from "../lib/constants";

export default function ArtisanSection() {
  return (
    <section
      data-testid="artisan-section"
      className="max-w-7xl mx-auto px-4 md:px-8 py-20 md:py-28"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        {/* Photo */}
        <div className="lg:col-span-5 relative">
          <div className="relative rounded-[2rem] overflow-hidden border border-slate-200 bg-gradient-to-br from-teal-50 to-slate-100">
            <img
              src={ARTISAN_PHOTO}
              alt="Votre artisan serrurier breton"
              className="w-full h-[480px] md:h-[560px] object-cover"
              data-testid="artisan-photo"
            />
            {/* Floating badge */}
            <div className="absolute top-5 left-5 bg-white rounded-2xl px-3 py-2 shadow-xl flex items-center gap-3">
              <img
                src={ARTISAN_BADGE}
                alt="Certification Artisan"
                className="h-12 w-auto object-contain"
                data-testid="artisan-certification-badge"
              />
              <div className="leading-tight pr-2">
                <div className="text-[10px] uppercase tracking-widest text-slate-500 font-bold">
                  Certifié
                </div>
                <div className="font-display font-extrabold text-slate-900 text-sm">
                  Artisan diplômé
                </div>
              </div>
            </div>
            <div className="absolute bottom-5 right-5 bg-slate-900 text-white rounded-2xl px-4 py-3 shadow-xl">
              <div className="text-[10px] uppercase tracking-widest text-teal-300 font-bold">
                Note Google
              </div>
              <div className="font-display font-extrabold text-2xl flex items-center gap-1">
                {COMPANY.googleRating}
                <Star className="w-4 h-4 fill-amber-400 text-amber-400 ml-0.5" />
              </div>
            </div>
          </div>
        </div>

        {/* Bio */}
        <div className="lg:col-span-7 space-y-6">
          <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-teal-700">
            <span className="h-px w-8 bg-teal-700" /> Votre artisan
          </div>
          <h2 className="font-display text-3xl md:text-5xl font-extrabold tracking-tight text-slate-900 leading-tight">
            Bonjour, je suis <span className="text-teal-600">François</span>,
            <br />
            <span className="text-teal-600">votre serrurier breton.</span>
          </h2>
          <p className="text-slate-700 text-lg leading-relaxed">
            {ARTISAN.intro}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 pt-2">
            <div className="bg-white border border-slate-200 rounded-2xl p-5">
              <ShieldCheck className="w-6 h-6 text-teal-600 mb-2" />
              <div className="font-display text-2xl font-extrabold text-slate-900">
                Diplômé
              </div>
              <div className="text-xs text-slate-500 font-semibold">
                Artisan certifié
              </div>
            </div>
            <div className="bg-white border border-slate-200 rounded-2xl p-5">
              <MapPin className="w-6 h-6 text-teal-600 mb-2" />
              <div className="font-display text-2xl font-extrabold text-slate-900">
                Local
              </div>
              <div className="text-xs text-slate-500 font-semibold">
                Basé à Mont-Dol
              </div>
            </div>
            <div className="bg-white border border-slate-200 rounded-2xl p-5">
              <Award className="w-6 h-6 text-teal-600 mb-2" />
              <div className="font-display text-2xl font-extrabold text-slate-900">
                +{COMPANY.interventions}
              </div>
              <div className="text-xs text-slate-500 font-semibold">
                Interventions
              </div>
            </div>
          </div>

          <div className="flex flex-wrap gap-3 pt-2">
            <a
              data-testid="artisan-cta-call"
              href={`tel:${COMPANY.phoneDigits}`}
              className="inline-flex items-center gap-2 bg-orange-600 hover:bg-orange-700 text-white font-bold rounded-full px-6 py-3.5 shadow-xl shadow-orange-600/30"
            >
              <Phone className="w-4 h-4" /> {COMPANY.phone}
            </a>
            <a
              data-testid="artisan-cta-callback"
              href="#callback"
              onClick={(e) => {
                e.preventDefault();
                window.dispatchEvent(new CustomEvent("open-callback"));
              }}
              className="inline-flex items-center gap-2 bg-white border-2 border-slate-900 hover:bg-slate-900 hover:text-white text-slate-900 font-bold rounded-full px-6 py-3.5 transition-colors"
            >
              Me faire rappeler
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
